import React, { useState } from "react";
import Marquee from "react-marquee-slider";
import Image from "next/image";

import defaultImage from "../../../../public/images/image20.jpeg";
import bgImg from "../../../../public/images/t19bg.png";

type Props = {
  sectionImage?: string;
};

interface FAQ {
  id: number;
  question: string;
  answer: string;
}

interface FAQCardProps {
  faq: FAQ;
}

const FAQ: React.FC<Props> = ({ sectionImage }) => {
  const staticData: FAQ[] = [
    {
      id: 1,
      question: "CAN I BRING A PLUS ONE?",
      answer:
        "No, every invited guest will receive their access card unique to them.",
    },
    {
      id: 2,
      question: "CAN WE BRING OUR KIDS?",
      answer: "No, this is strictly by invitation.",
    },
    {
      id: 3,
      question: "WHEN IS THE RSVP DEADLINE?",
      answer:
        "Please RSVP by the 21st of September, so we can have an accurate headcount.",
    },
    {
      id: 4,
      question: "OTHER THINGS TO NOTE:",
      answer:
        "Your ACCESS CODE is unique to you and cannot be shared with anyone else.",
    },
    {
      id: 5,
      question: "CAN WE BRING GIFTS?",
      answer:
        "We are incredibly grateful for your generosity and support, if you're considering giving us a gift, a cash donation would mean so much to us. Your kindness will help us create a welcoming home for our family. Thank you for being part of this special journey with us. For this purpose, please reach out to any of us before or after our ceremony.",
    },
  ];

  const FAQCard: React.FC<FAQCardProps> = ({ faq }) => (
    <div className="p-4 flex flex-col justify-center items-center text-center text-[#FCE2B0] gap-1">
      <h3 className="text-xl font-semibold font-ebGaramond tracking-wider uppercase max-w-[85%] sm:max-w-2xl">
        {faq.question}
      </h3>
      <p className="text-lg font-ebGaramond max-w-[85%] sm:max-w-2xl text-[#FFF3DB] whitespace-pre-line">
        {faq.answer}
      </p>
    </div>
  );

  return (
    <div className="w-full flex flex-col lg:flex-row">
      {/* Content Section - Takes natural height on mobile, centered on desktop */}
      <div className="w-full lg:flex-1 lg:h-full relative order-1 lg:order-2">
        {/* Background image */}
        <div className="absolute inset-0">
          <Image
            src={bgImg}
            alt="background"
            layout="fill"
            className="object-cover object-center"
          />
        </div>

        <div className="relative z-10 w-full h-full flex flex-col justify-center items-center py-12 lg:py-24 px-6 lg:px-10">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-ntFab text-[#FCE2B0] mb-8 lg:mb-12">
            Q & A
          </h1>
          <div className="flex flex-col gap-6 lg:gap-8 max-w-4xl w-full">
            {staticData.map((faq) => (
              <FAQCard key={faq.id} faq={faq} />
            ))}
          </div>
        </div>
      </div>

      {/* Image Section - Fixed height on mobile, follows content */}
      <div className="w-full h-[50vh] lg:flex-1 lg:h-full order-2 lg:order-1 lg:hidden">
        <div className="relative w-full h-full">
          <Image
            loading="eager"
            layout="fill"
            src={sectionImage || defaultImage}
            alt="romantic-quote-image"
            className="object-cover object-center lg:object-top"
            sizes="(max-width: 1024px) 100vw, 50vw"
          />
        </div>
      </div>
    </div>
  );
};

export default FAQ;
